import React, { useState, useEffect } from 'react';
import { Input } from './ui/input';
import { formatPercent } from '../lib/format';
import { toast } from 'sonner';

/**
 * Cella editabile inline per valori percentuali (0..1 memorizzati, mostrati in %).
 * Consente di modificare il valore direttamente in tabella senza aprire la scheda.
 * onSave(pct) riceve la nuova frazione (0..1) e deve restituire una Promise.
 */
export const InlinePctCell = ({ row, field, canWrite, onSave, decimals = 1, min = null, testid }) => {
  const toStr = (v) => String(Math.round(((v || 0) * 100) * 100) / 100);
  const [val, setVal] = useState(toStr(row[field]));
  useEffect(() => { setVal(toStr(row[field])); }, [row[field]]);

  const save = async () => {
    let pct = (parseFloat(String(val).replace(',', '.')) || 0) / 100;
    if (min != null) pct = Math.max(min, pct);
    if (Math.abs(pct - (row[field] || 0)) < 1e-9) return;
    try { await onSave(pct); toast.success('Aggiornato'); }
    catch (e) { toast.error('Errore aggiornamento'); setVal(toStr(row[field])); }
  };

  if (!canWrite) return <span className="tabular-nums">{formatPercent(row[field] || 0, decimals)}</span>;
  return (
    <div onClick={(e) => e.stopPropagation()} className="flex items-center justify-end gap-1">
      <Input
        type="number"
        value={val}
        onChange={(e) => setVal(e.target.value)}
        onBlur={save}
        onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); e.currentTarget.blur(); } }}
        className="h-7 w-[4.5rem] text-right tabular-nums px-2"
        step="0.1"
        data-testid={testid}
        aria-label={`Modifica ${field}`}
      />
      <span className="text-xs text-muted-foreground">%</span>
    </div>
  );
};
